function waitForElement(selector, callback) {
  const interval = setInterval(function() {
    const element = document.querySelector(selector);
    if (element) {
      clearInterval(interval);
      callback(element);
    }
  }, 300); // 每300毫秒檢查一次
}

document.addEventListener("DOMContentLoaded", function() {
    // 撰寫評價修改文字
    waitForElement('.yotpo-body-text', function(titleElement) {
      titleElement.textContent = '尚無評價，要立即寫一則嗎？';
    });
  
    waitForElement('.yotpo-new-review-btn', function(reviewBtnElement) {
      reviewBtnElement.textContent = '撰寫評價';
    });
});

// footer新增常見問題
document.addEventListener("DOMContentLoaded", function() {
  // 找到目標 ul
  const footerList = document.querySelector(".footer-block__details-content.list-unstyled");
  if (!footerList) return;

  // 建立新的 li 元素
  const newLi = document.createElement("li");
  newLi.innerHTML = `
    <a href="/pages/faqs" class="link link--text list-menu__item list-menu__item--link">
      常見問題
    </a>
  `;

  // 插入到最後面
  footerList.appendChild(newLi);
});